// The official Pixel runs in a disposable document with clean URLs and no form
// fields. Never pass location.search, location.hash, referrers or user input.
export const CONSENT_KEY = 'logic-gates-meta-marketing-v1';
const PATHS = new Set(['/', '/product/logic-learner', '/product/logic-gates', '/about', '/logic-wiki']);
const PRODUCT = { content_name: 'Logic Trainer', content_ids: ['logic-trainer'] };
let choice = readConsent();
let frame;
let ready = false;
let pending = [];
let lastPath;

export function readConsent() {
  try {
    const value = localStorage.getItem(CONSENT_KEY);
    return value === 'accepted' || value === 'rejected' ? value : null;
  } catch { return null; }
}

export function currentConsent() { return choice; }
function safePath(path) { return PATHS.has(path.replace(/\/$/, '') || '/') ? path.replace(/\/$/, '') || '/' : '/404'; }

function flush() {
  if (choice !== 'accepted' || !ready || !frame) return;
  const events = pending;
  pending = [];
  events.forEach(({ path, event, data }) => frame?.contentWindow.sendMetaEvent(path, event, data));
}

function start(path) {
  if (frame || choice !== 'accepted') return;
  const element = document.createElement('iframe');
  frame = element;
  element.hidden = true;
  element.title = 'Marketing tracking';
  element.setAttribute('aria-hidden', 'true');
  element.tabIndex = -1;
  element.referrerPolicy = 'no-referrer';
  element.src = '/meta-pixel.html';
  element.onload = () => {
    if (frame !== element || choice !== 'accepted') return;
    element.contentWindow.startMetaPixel(path, () => {
      if (frame !== element || choice !== 'accepted') return;
      ready = true;
      flush();
    });
  };
  document.body.appendChild(element);
}

function send(path, event, data = {}) {
  if (choice !== 'accepted') return;
  pending.push({ path: safePath(path), event, data });
  start(safePath(path));
  flush();
}

export function trackPage(pathname) {
  if (choice !== 'accepted') return;
  const path = safePath(pathname);
  // Module lifetime survives rerenders, Strict Mode effect replay and remounts.
  // Hash/query changes are not new pages; returning from another path is.
  if (path === lastPath) return;
  lastPath = path;
  send(path, 'PageView');
  if (path === '/product/logic-learner') {
    send(path, 'ViewContent', { ...PRODUCT, content_type: 'product' });
  }
}

export function setConsent(value, persist = true) {
  choice = value === 'accepted' ? 'accepted' : value === 'rejected' ? 'rejected' : null;
  if (persist) {
    try { localStorage.setItem(CONSENT_KEY, choice); } catch { /* Session-only if storage is unavailable. */ }
  }
  if (choice !== 'accepted') {
    ready = false;
    pending = [];
    lastPath = undefined;
    // Revoke first, then destroy the execution context, timers and queued work.
    frame?.contentWindow.stopMetaPixel?.();
    frame?.remove();
    frame = undefined;
    for (const name of ['_fbp', '_fbc']) {
      for (const domain of ['', location.hostname, `.${location.hostname}`]) {
        document.cookie = `${name}=; Max-Age=0; path=/;${domain ? ` domain=${domain};` : ''} SameSite=Lax`;
      }
    }
  }
}

export function trackBuyActivation(event) {
  if (choice !== 'accepted' || (event.type === 'auxclick' ? event.button !== 1 : event.button !== 0)) return;
  const anchor = event.target.closest?.('a[href]');
  if (!anchor) return;
  const url = new URL(anchor.href);
  if (url.protocol !== 'https:' || !['www.tindie.com', 'tindie.com'].includes(url.hostname) || url.pathname !== '/products/40140/') return;
  send(location.pathname, 'TindieClick', PRODUCT);
  // No preventDefault, callback, delay, window.open, or checkout/purchase event.
}
